// From '@symbo.ls/utils', not the 'smbls' barrel — keeps the framework bundle
// out of the eager chunk (same fix as workspace/functions/extensionDesignSystem.js).
import { deepMerge, deepClone } from '@symbo.ls/utils'

export function prepareFrameProps(scope, state) {
  const { frameProps } = scope

  return deepMerge(
    {
      ':focus-within': { outline: 'none' },
      ...frameProps,
      ...state.props
    },
    {
      zoom: this.getUserSettings('zoomLevel'),
      direction: this.getUserSettings('languageDirection')
    }
  )
}

// USER-CODE-ORIGIN review N4: a copy AS STORED — the shell never revives
// member-authored project code (the opaque user-code frame does).
export function prepareCode(code) {
  return deepClone(code)
}

export function prepareRouter(data, scope) {
  return scope.router || scope.useRouter
    ? // handle direct routing
      (path) =>
        this.call(
          'router',
          scope.activeItem || path || '',
          this,
          {},
          {
            window: window.top || window
          }
        )
    : // handle canvas routing
      function (path, ...params) {
        if (
          typeof path !== 'string' ||
          !path.startsWith('/') ||
          !(this.getRootState() && this.getUserSettings('allowCanvasReplaceRouter')) ||
          params[2]?.initialRender
        )
          return
        window.setTimeout(() => {
          const chosen = this.getChosenKey()
          const key = '/' + path.split('/')[1]
          this.activateSelected(key)
          if (!chosen) {
            this.zoomToNode(this.getSelected())
          }
        }, 1)
      }
}

export function prepareUtils(data, scope) {
  const router = this.prepareRouter?.(data, scope)
  return {
    ...data?.functions,
    ...data?.snippets,
    router
  }
}

// The platform methods come from the running element's own methods bag, not
// from a namespace import of this folder: frank cannot serialize an
// `import * as X` read as a value (unresolved-namespace-object), and the bag
// already holds every registered method of this library.
export function prepareMethods(data, scope) {
  const router = this.prepareRouter?.(data, scope)
  return {
    ...this.context?.methods,
    ...data?.methods,
    router
  }
}

// The `emotion` second parameter was dropped 2026-07-27 along with
// `methods/renderer-component.js` — it was the only caller that ever passed
// one, and v3.14 has no emotion layer at all (the `@symbo.ls/css` atomic
// engine replaced it). The surviving caller, `renderer-canvas.js`, always
// called this with a single argument, so the emitted `emotion: undefined` key
// was dead weight in every `initOptions` this produced.
export function prepareInitOptions(scope) {
  return {
    ...scope.initOptions,
    newConfig: {}
  }
}
